import React, { useState } from 'react';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import careCredit from 'src/assets/images/care-credit-img.png';
import careCreditBanner from 'src/assets/images/care-credit-banner.png';
import { Link } from 'react-router-dom';
import { CURRENCY } from 'src/lib/constans';

const WebCareCredits: React.FC = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    return (
        <>
            <div className={`${isLoggedIn ? 'pharmacy-banner' : 'care-credit-banner'}`}>
                <div className="container-1400">
                    {isLoggedIn ? (
                        <div className='p-4'>
                            <div className='care-credit-banner-inner'>
                                <img src={careCreditBanner} alt="" />
                                <span className='text-white font-Poppins-Bold font-size-20px care-credit-banner-inner-btn'>Stay Healthy, Stay Rewarded</span>
                                <div className='care-creidt-point-web'>
                                    <div className='care-creidt-point-web-first'>
                                        <span className='theme-color-green font-Poppins-SemiBold font-size-20px'>500</span>
                                        <span className='theme-color-green font-Poppins-Medium font-size-16px'>Points</span>
                                    </div>
                                    <div className='care-creidt-point-web-second'>
                                        <span className='theme-color-green font-Poppins-SemiBold font-size-20px'>5</span>
                                        <span className='theme-color-green font-Poppins-Medium font-size-16px'>{CURRENCY}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='care-credit-banner-main-content'>
                                <h2 className='text-[#3E3E3E] font-size-22px font-Poppins-Medium'>How to earn Care Credits?</h2>
                                <ul>
                                    <li className='text-[#707070] font-size-15px font-Poppins-Regular'>Consult with our doctors</li>
                                    <li className='text-[#707070] font-size-15px font-Poppins-Regular'>Purchase items from Healthcare pharmacy
                                    </li>
                                    <li className='text-[#707070] font-size-15px font-Poppins-Regular'>Purchase tests from Healthcare
                                    </li>
                                    <li className='text-[#707070] font-size-15px font-Poppins-Regular'>Purchase from Healthcare's Homecare service</li>
                                </ul>
                                <div>
                                    <p className='text-[#707070] font-size-15px font-Poppins-Regular'>For every 100 {CURRENCY} shopping, you will get 10 Care Credits.
                                    </p>
                                    <span className='text-[#619B97] font-size-15px font-Poppins-Regular'>*T&C Applied</span>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='care-credit-web-innr-wait'>
                            <div className="product-by-categories-right">
                                <span className="font-Poppins-Medium text-white product-by-categories-head-result font-size-18px">Care Credit</span>
                                <div className='care-credit-web'>
                                    <img src={careCredit} alt="" />
                                    <div className='care-credit-web-inner'>
                                        <span className='text-[#2F2F31] font-Poppins-SemiBold font-size-25px'>Login to View Care Credit</span>
                                        <p className='text-[#707070] font-Poppins-Regular font-size-18px'>Please Login/Register first to access this section</p>
                                    </div>
                                    <PrimaryBtn onPress={() => setIsLoggedIn(!isLoggedIn)} btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem", padding: "0.5rem 2.5rem" }} ButtonText='Login/Register' />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="bg-white py-4">
                <div className="container-1400">
                </div>
            </div>
        </>
    );
};

export default WebCareCredits;